import React from 'react';
import { mergeStyleSets } from '@fluentui/react';

import { upToMediumScreenSelector } from 'utils/breakpoints';

export interface StepContainerProps {
	children: JSX.Element | JSX.Element[],
	className?: string
}

export const StepContainer = ({ children, className = '' }: StepContainerProps) => {
	return <div className={`${styles.root} ${className}`}>{children}</div>;
};

const styles = mergeStyleSets({
	root: {
		padding: '2rem',
		flexBasis: 'auto',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		overflowY: 'auto',
		selectors: {
			[upToMediumScreenSelector]: {
				padding: '1.5rem'
			}
		}
	}
});
